import React from 'react';
import CourtesyPage from '../CourtesyPage';

const ReadyCourtesyPage: React.FC = () => {

	return (
		<CourtesyPage messageID={'ready'} />
	)
}

export default ReadyCourtesyPage;
